<script lang="ts">
  import { onMount } from 'svelte';
  import { M4 } from '../modules';

  let log: string[] = [];

  onMount(() => {
    log = M4?.getLog?.() ?? [];
    // Subscribe to live updates so the list refreshes when new tracks are detected
    if (M4?.onLogUpdate) {
      const unsub = M4.onLogUpdate((updatedLog: string[]) => {
        log = updatedLog;
      });
      return () => unsub?.(); // cleanup on destroy
    }
  });
</script>

<div id="recent-count">{log.length} track(s) played</div>
<ol id="recent-list">
  {#each log as entry, i}
    <li><span class="recent-num">{i + 1}.</span>{entry}</li>
  {:else}
  {/each}
</ol>
